import { useRef } from 'react';
import {
  useDateFormatPreference,
  useWeekStartsOnPreference,
} from '@witmetrics/data-store';
import { formatDayOfWeek, formatTextDate } from '@witmetrics/utils/time';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import IconButton from '@/components/IconButton';
import { CaretLeftIcon, CaretRightIcon, CloseIcon } from '@/icons';
import DateTimePopover from '@/components/DateTimePopover';
import { classes } from './utils';

export type HeaderProps = {
  onClose: () => void;
};

export default function Header({ onClose }: HeaderProps) {
  const menuToggleRef = useRef(null);
  const { activeCalendarDate, onOpenAgenda } = useAppState();
  const dateFormat = useDateFormatPreference();
  const weekStartsOn = useWeekStartsOnPreference();
  const [isMenuOpen, toggleMenu] = useToggle();

  const handleIncrement = (increment: number) => {
    let date = new Date(activeCalendarDate!);
    date.setDate(date.getDate() + increment);
    onOpenAgenda(date.toISOString());
  };

  const handleSelectDate = ({ date }: { date: Date }) =>
    onOpenAgenda(date.toISOString());

  return (
    <div className={classes.wrapper}>
      <div>
        {activeCalendarDate && (
          <div className={classes.dateWrapper}>
            <div>
              <IconButton
                className={classes.iconButton}
                onClick={() => handleIncrement(-1)}>
                <CaretLeftIcon />
              </IconButton>
              <IconButton
                className={classes.iconButton}
                onClick={() => handleIncrement(1)}>
                <CaretRightIcon />
              </IconButton>
            </div>
            <h1
              ref={menuToggleRef}
              className={classes.date}
              onClick={() => toggleMenu()}>
              {`${formatDayOfWeek(activeCalendarDate, false)}, ${formatTextDate(
                activeCalendarDate,
                dateFormat
              )}`}
            </h1>
            {isMenuOpen && (
              <DateTimePopover
                anchorTo={menuToggleRef.current}
                open
                closeOnSelect
                disablePast={false}
                showTime={false}
                className={classes.dateMenu}
                name="date"
                value={new Date(activeCalendarDate)}
                weekStartsOn={weekStartsOn}
                onChange={handleSelectDate}
                onClose={() => toggleMenu(false)}
              />
            )}
          </div>
        )}
      </div>
      <IconButton aria-label="close" onClick={onClose}>
        <CloseIcon className={classes.closeButton} />
      </IconButton>
    </div>
  );
}
